<template>
  <div class="card">
    <h3>Ownership</h3>
    <div class="table-wrap compact-table-wrapper">
      <table class="compact-table">
        <thead>
          <tr>
            <th>Holder</th>
            <th>CIQ ID</th>
            <th>Shares</th>
            <th>Value</th>
            <th>% of Portfolio</th>
            <th>% Ownership</th>
            <th>Change QoQ</th>
            <th>Position Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(o,i) in items" :key="i">
            <td>{{ o.holderName || o.ciqId }}</td>
            <td>{{ o.ciqId || '-' }}</td>
            <td class="num">{{ formatNumber(o.holderShare) }}</td>
            <td class="num">{{ formatNumber(o.holderValue) }}</td>
            <td class="num">{{ o.holderEquity === 0 ? "-" : formatPct(o.holderValue / o.holderEquity * 100) }}</td>
            <td class="num">{{ formatPct(o.holderPercent) }}</td>
            <td class="num">{{ formatNumber(o.changeQoQ) }}</td>
            <td>{{ formatDate(o.positionDate) }}</td>
          </tr>
          <tr v-if="items.length===0"><td colspan="8" class="empty">No ownership data</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ownership',
  props: { items: { type: Array, default: () => [] } },
  methods: {
    formatNumber(v){ return (v || v===0) ? Number(v).toLocaleString() : '-' },
    formatPct(v){ return (v || v===0) ? (Number(v).toFixed(2) + '%') : '-' },
    formatDate(d){ return (d && d.format) ? d.format('DD-MMM-YYYY') : (d || '-') }
  }
}
</script>

<style scoped>
.card{ padding: var(--mobile-card-padding); border-bottom: 1px solid var(--compact-table-border) }
.table-wrap{ overflow-x:auto }
table{ width:100%; border-collapse:collapse; min-width:0; table-layout:auto }
th,td{ border:0; padding:var(--compact-table-cell-padding); font-size:var(--compact-table-font-size) }
.num{ text-align:right }
.empty{ color:#777; padding:6px 0; text-align:center }
tbody tr{ border-bottom:1px solid var(--compact-table-border) }
tbody tr:nth-child(odd){ background:var(--compact-table-zebra) }
</style>
